import DashboardLayout from "./layout/DashboardLayout";
import Transaction from "./Transcation";

const TransactionComponent = () => {
  return (
    <DashboardLayout>
      <Transaction />
    </DashboardLayout>
  );
};

export default TransactionComponent;
